import React, { useState } from "react";
import { Alert } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import moment from "moment";
import { CalendarBusinessInfo } from "../calendarViewTypes";
import styles from "../CalendarView.module.css";

const shouldShowTrialBanner = (businessInfo: CalendarBusinessInfo | null) => {
  if (!businessInfo?.free_trial_end_date || businessInfo?.status === "Active") {
    return false;
  }
  const trialEndDate = moment(businessInfo.free_trial_end_date);
  const daysUntilEnd = trialEndDate.diff(moment(), "days");
  return (
    (businessInfo.status === "Trial" || businessInfo.status === "Inactive") &&
    daysUntilEnd <= 7 &&
    daysUntilEnd >= 0
  );
};

const getTrialMessage = (businessInfo: CalendarBusinessInfo | null) => {
  const daysLeft = moment(businessInfo?.free_trial_end_date).diff(
    moment(),
    "days",
  );
  return `Your free trial ends in ${daysLeft} days. Finalize your subscription in the Settings page.`;
};

/** Dismissible "trial ending soon" alert (last 7 days of a trial). */
const TrialBanner: React.FC<{ businessInfo: CalendarBusinessInfo | null }> = ({
  businessInfo,
}) => {
  const [showTrialBanner, setShowTrialBanner] = useState(true);
  if (!(shouldShowTrialBanner(businessInfo) && showTrialBanner)) return null;
  return (
    <Alert
      icon={<IconAlertCircle size={16} />}
      title="Trial Period Ending Soon"
      withCloseButton
      onClose={() => setShowTrialBanner(false)}
      className={styles.trialBanner}
    >
      {getTrialMessage(businessInfo)}
    </Alert>
  );
};

export default TrialBanner;
